import React,{useState} from "react";

import { fetchCall } from "../../common/FetchHelpers";

const ReqActionBar = (props) => {
       
    const reqUrl = "api/emp-request/withdraw";

    const[formState,setFormState] = useState("VIEW");
    const[statusMsg,setStatusMsg] = useState({style:"",msg:""});

    const handleWithdraw = ()=>{
        setFormState("WITHDRAW");
        setStatusMsg({style:"form-status warning",msg:"Are you sure you want to withdraw this request?"});
    };

    const handleCancel = ()=>{
        setFormState("VIEW");
        setStatusMsg({style:"",msg:""});
    };

    const handleSubmit = () =>{

        const fData = new FormData();
        fData.append("id",props.reqId);
        fData.append("reqType",props.reqType);

        const reqOptions = {
            method: "POST",
            body: fData,
        };

        fetchCall(reqUrl, reqOptions)
            .then((result)=>{
                if(result.status === "SUCCESS"){
                    if(result.requestStatus === "Withdrawn"){
                        setStatusMsg({style:"form-status success",msg:"This Request has successfully Withdrawn"});
                    }
                    setFormState("SAVED");
                    props.reloadItem(props.reqId);
                }
            },
            (err)=>{
                setStatusMsg({style:"form-status warning",msg:"There is a internal error, Please contact your manager"});
            }
        );
    };

    return (
        <div className="panel-footer">
            <div className={statusMsg.style}>{statusMsg.msg}</div>
            <div className="btn-group">
                {formState ==="VIEW" && 
                <>
                    <button id="btnUpdate" type="button" className="btn btn-primary" onClick={props.handleUpdate}>Update</button>
                    {props.reqStatus !=="Withdrawn" && 
                        <button id="btnWithdraw" type="button" className="btn btn-primary" onClick={handleWithdraw}>Withdraw</button>
                    }
                </>  
                }

                { formState==="WITHDRAW" && 
                <>
                    <button id="btnCancel" type="button" className="btn btn-primary-outline" onClick={handleCancel}>Cancel Withdraw</button>
                    <button id="btnWithdraw" type="button" className="btn btn-primary" onClick={handleSubmit}>Submit Withdraw</button>
                </>
                }
                {formState !=="WITHDRAW" &&
                    <button id="btnCloseDetails" type="button" className="btn btn-primary-outline" onClick={props.handleClose}>Close</button>
                }

            </div>
        </div>
    )
}

export default ReqActionBar
